<script>
import { formatDate } from '@speechki-frontend/shared/helpers/functions';
import { ITEM_STATES, DATE_PATTERN, TIME_PATTERN, GROUP_BY } from '../../utils';
import transitions from '../../transitions';

export default {
    name: 'NotificationsIterator',
    mixins: [transitions],
    props: {
        groupByDate: {
            type: Boolean,
            default: false,
        },
        excludeState: {
            type: String,
            default: '',
        },
        filter: {
            type: Function,
            default: (item) => !!item.id,
        },
        lazyFetch: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            notifications: [],
            pagination: {},
        };
    },
    computed: {
        filteredItems() {
            if (!this.notifications.length) return [];
            return this.notifications.slice().filter(this.filter);
        },
        computedItems() {
            return this.filteredItems.slice().map((item) => ({
                ...item,
                formattedDate: formatDate(item.modified, { pattern: DATE_PATTERN }),
                formattedTime: formatDate(item.modified, { pattern: TIME_PATTERN }),
                select: (v) => this.$transition({ type: 'REDIRECT', item, v }),
            }));
        },
        groupedItems() {
            let items = this.computedItems.slice();

            if (this.groupByDate) {
                items = items = items.reduce(
                    (acc, cur) => ({
                        ...acc,
                        [cur[GROUP_BY]]: (acc[cur[GROUP_BY]] || []).concat(cur),
                    }),
                    {}
                );
            }

            return items;
        },
        computedPagination() {
            const { next, page = 1 } = this.pagination;
            return {
                ...this.pagination,
                hasNext: !!next,
                next: () => {
                    const params = { page: page + 1 };
                    return this.$transition({ type: 'FETCH', params });
                },
            };
        },
        fetchParams() {
            const params = {};
            if (this.excludeState) params.state_not = this.excludeState;
            return params;
        },
        scopedProps() {
            return {
                loading: this.loading,
                items: this.computedItems,
                groupedItems: this.groupedItems,
                pagination: this.computedPagination,
                noData: !this.filteredItems.length,
                hasNewest: this.notifications.some(({ state }) => state === ITEM_STATES.initial),
                fetch: this.fetch,
                update: this.update,
                clearAll: this.clearAll,
            };
        },
    },
    created() {
        if (!this.lazyFetch) {
            this.fetch();
        }
    },
    methods: {
        reset() {
            return this.$transition({ type: 'RESET' });
        },
        fetch(page = 1) {
            return this.$transition({ type: 'FETCH', params: { page } });
        },
        update(event) {
            return this.$transition({ type: 'UPDATE', ...event });
        },
        clearAll() {
            const { finite: state } = ITEM_STATES;
            this.update({ state });
            this.notifications = [];
        },
    },
    render() {
        return this.$slots.default && this.$slots.default(this.scopedProps);
    },
};
</script>
